import React, { FC } from 'react';

export const WhaleIcon: FC = () => {
  return (
    <svg
      width='120'
      height='147'
      viewBox='0 0 120 147'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M54.542 107.701C84.0404 110.162 112.178 92.5702 114.639 63.0718C117.101 33.5733 95.1828 7.66479 65.6843 5.20342C40.1283 3.07101 17.2668 19.2368 10.0119 42.7774C3.4297 58.6105 8.80219 107.192 15.9988 123.1C12.9401 125.416 6.73862 131.236 6.40202 135.988C10.7238 138.827 20.6387 141.881 25.7239 131.387C29.0167 133.429 37.638 136.356 45.7817 131.722C46.0367 128.122 42.5428 120.746 26.5272 120.046C24.8187 113.384 28.2184 104.641 38.0825 104.005C43.1085 105.945 48.6281 107.207 54.542 107.701Z'
        fill='url(#paint0_linear_11001_159644)'
      />
      <line
        x1='59.9335'
        y1='72.4895'
        x2='81.4549'
        y2='71.101'
        stroke='#6A7695'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.7678 43.0503L10.7531 43.0856C9.16361 46.909 8.26894 52.7976 7.96039 59.8056C7.65283 66.7911 7.93016 74.8086 8.6379 82.8399C10.0564 98.9366 13.1907 114.945 16.7302 122.769L16.9943 123.353L16.4834 123.74C14.9927 124.868 12.723 126.863 10.7929 129.148C8.97761 131.298 7.57076 133.581 7.25633 135.579C9.34422 136.847 12.5207 138.056 15.7342 137.886C19.0928 137.708 22.5847 136.025 25.0016 131.037L25.39 130.235L26.1471 130.705C29.2443 132.626 37.3123 135.365 44.9902 131.242C44.9532 129.708 44.1712 127.448 41.7405 125.412C39.0746 123.179 34.3882 121.193 26.4922 120.848L25.8975 120.822L25.7497 120.246C24.8463 116.723 25.2884 112.648 27.2779 109.351C29.2851 106.024 32.8404 103.538 38.0309 103.204L38.207 103.193L38.3716 103.256C43.3223 105.167 48.7667 106.413 54.6088 106.901C83.8037 109.337 111.425 91.935 113.839 63.005C116.264 33.9484 94.6742 8.42786 65.6176 6.00335C40.4453 3.90295 17.9251 19.826 10.779 43.0138L10.7678 43.0503ZM45.7817 131.722C38.16 136.059 30.12 133.773 26.4213 131.788C26.168 131.652 25.935 131.518 25.7239 131.387C25.6045 131.633 25.4824 131.872 25.3578 132.104C20.176 141.738 10.6223 138.761 6.40201 135.988C6.73862 131.236 12.9401 125.416 15.9988 123.1C8.80219 107.192 3.4297 58.6105 10.0119 42.7774C17.2668 19.2368 40.1283 3.07101 65.6843 5.20342C95.1828 7.66479 117.101 33.5733 114.639 63.0718C112.178 92.5702 84.0404 110.162 54.542 107.701C48.6281 107.207 43.1085 105.945 38.0825 104.005C28.2184 104.641 24.8187 113.384 26.5272 120.046C42.5428 120.746 46.0367 128.122 45.7817 131.722Z'
        fill='#6A7695'
      />
      <path
        d='M43.4999 50.501C44.9823 49.6287 46.7925 49.6406 47.9363 49.4504C47.4952 48.4285 44.0133 48.6946 42.7188 49.0663C41.6833 49.3636 41.5004 49.8947 41.551 50.1992C41.627 50.6559 42.7644 50.9338 43.4999 50.501Z'
        fill='#6A7695'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M48.5078 49.7624L48.3046 49.2915C48.1171 48.8573 47.6536 48.6392 47.2237 48.5203C46.7681 48.3944 46.2126 48.3422 45.6528 48.3346C44.5344 48.3194 43.3001 48.4819 42.6078 48.6807C42.0387 48.8441 41.652 49.0863 41.4158 49.3773C41.1762 49.6724 41.1102 49.9968 41.1549 50.2652C41.1999 50.5362 41.3894 50.7226 41.5656 50.8368C41.7487 50.9556 41.9734 51.035 42.2038 51.0783C42.6595 51.1639 43.2319 51.1244 43.7032 50.8471C44.3839 50.4465 45.1522 50.2421 45.9107 50.116C46.2893 50.053 46.6595 50.0104 47.0131 49.9712C47.0413 49.9681 47.0694 49.965 47.0975 49.9619C47.4167 49.9266 47.7268 49.8923 48.0019 49.8465L48.5078 49.7624ZM46.6057 49.2096C46.3419 49.2407 46.0637 49.2768 45.779 49.3242C44.9758 49.4577 44.0978 49.6835 43.2961 50.1553C43.0319 50.3107 42.6678 50.3487 42.352 50.2894C42.1966 50.2602 42.0767 50.2116 42.0022 50.1633C41.9688 50.1417 41.9523 50.1256 41.9449 50.1171C41.9423 50.0733 41.9533 49.9887 42.039 49.8832C42.1405 49.7581 42.363 49.5861 42.8294 49.4522C43.4315 49.2793 44.5854 49.1229 45.6419 49.1373C45.9912 49.142 46.319 49.1654 46.6057 49.2096Z'
        fill='#6A7695'
      />
      <path
        d='M96.2654 49.0586C94.9568 47.9424 93.1719 47.6402 92.0785 47.2545C92.6902 46.3246 96.0732 47.1906 97.2835 47.7811C98.2517 48.2536 98.3398 48.8084 98.2371 49.0995C98.0831 49.5361 96.9147 49.6125 96.2654 49.0586Z'
        fill='#6A7695'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M91.4613 47.4625L91.7432 47.034C92.0031 46.6388 92.4974 46.5044 92.9414 46.462C93.412 46.417 93.9681 46.4619 94.5208 46.5516C95.6248 46.7306 96.8122 47.1047 97.4595 47.4205C97.9916 47.6802 98.3305 47.9858 98.5127 48.3133C98.6974 48.6455 98.7061 48.9765 98.6156 49.2331C98.5242 49.4921 98.3053 49.6429 98.112 49.7248C97.911 49.81 97.6759 49.8492 97.4415 49.8519C96.9779 49.8571 96.421 49.7189 96.005 49.3641C95.4041 48.8516 94.6828 48.5169 93.9577 48.2612C93.5958 48.1335 93.2386 48.0274 92.8972 47.9274C92.87 47.9194 92.8428 47.9115 92.8157 47.9035C92.5074 47.8134 92.208 47.7258 91.945 47.6331L91.4613 47.4625ZM93.4305 47.248C93.6849 47.3243 93.9526 47.4082 94.2248 47.5042C94.9926 47.775 95.8181 48.1497 96.5259 48.7534C96.7591 48.9523 97.1111 49.0529 97.4324 49.0492C97.5905 49.0475 97.717 49.0204 97.7987 48.9857C97.8354 48.9702 97.8545 48.9572 97.8632 48.9502C97.8734 48.9075 97.8772 48.8223 97.8111 48.7035C97.7329 48.5627 97.5436 48.3547 97.1075 48.1419C96.5445 47.8672 95.4352 47.513 94.3923 47.3439C94.0474 47.288 93.7205 47.2541 93.4305 47.248Z'
        fill='#6A7695'
      />
      <path
        d='M49.197 60.3812C49.197 62.5978 47.4001 64.3947 45.1834 64.3947C42.9668 64.3947 41.1699 62.5978 41.1699 60.3812C41.1699 58.1646 42.9668 56.3677 45.1834 56.3677C47.4001 56.3677 49.197 58.1646 49.197 60.3812Z'
        fill='#6A7695'
      />
      <path
        d='M45.4034 60.1564C45.2313 59.5141 45.6125 58.8539 46.2548 58.6818C46.8972 58.5097 47.5574 58.8908 47.7295 59.5332C47.9016 60.1755 47.5204 60.8357 46.8781 61.0078C46.2358 61.1799 45.5755 60.7988 45.4034 60.1564Z'
        fill='white'
      />
      <path
        d='M98.3383 58.7757C98.3383 60.9923 96.5414 62.7893 94.3248 62.7893C92.1082 62.7893 90.3113 60.9923 90.3113 58.7757C90.3113 56.5591 92.1082 54.7622 94.3248 54.7622C96.5414 54.7622 98.3383 56.5591 98.3383 58.7757Z'
        fill='#6A7695'
      />
      <path
        d='M92.1366 59.3537C91.9645 58.7114 92.3457 58.0512 92.988 57.879C93.6303 57.7069 94.2905 58.0881 94.4626 58.7304C94.6348 59.3728 94.2536 60.033 93.6112 60.2051C92.9689 60.3772 92.3087 59.996 92.1366 59.3537Z'
        fill='white'
      />
      <path
        d='M40.3417 89.4112C67.5584 73.0961 96.6156 82.3185 105.113 86.8303C98.9071 96.0914 80.2084 110.133 51.3312 108.503C41.08 107.648 37.7658 107.138 34.8758 104.891C29.5033 105.342 27.0794 112.599 26.0461 113.721C25.7129 112.888 26.6618 109.539 26.8487 107.299C27.0356 105.06 27.6514 102.884 30.6942 98.5404C34.8758 93.6533 39.2907 90.0412 40.3417 89.4112Z'
        fill='url(#paint1_linear_11001_159644)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.1352 89.0669C67.5191 72.6516 96.7363 81.9282 105.301 86.4758L105.693 86.6843L105.446 87.0537C99.16 96.4348 80.3248 110.541 51.3085 108.904L51.3031 108.904L51.2978 108.903C41.2313 108.063 37.7323 107.558 34.757 105.306C32.3316 105.575 30.5222 107.341 29.1625 109.284C28.4733 110.27 27.9148 111.279 27.4592 112.122C27.4132 112.207 27.368 112.291 27.3239 112.373C27.1511 112.694 26.9925 112.989 26.85 113.237C26.6753 113.542 26.5046 113.815 26.3412 113.993L25.9098 114.461L25.6733 113.87C25.606 113.701 25.5821 113.503 25.576 113.31C25.5696 113.111 25.5816 112.884 25.605 112.642C25.6518 112.159 25.7476 111.578 25.8572 110.967C25.8997 110.73 25.9442 110.488 25.989 110.245C26.1787 109.215 26.3748 108.152 26.4487 107.266C26.6432 104.935 27.2956 102.693 30.3653 98.3101L30.3765 98.2942L30.3891 98.2794C32.4929 95.8208 34.6543 93.6838 36.4223 92.0819C38.1812 90.4883 39.5729 89.404 40.1352 89.0669ZM104.526 86.9775C95.6166 82.4358 67.1863 73.787 40.548 89.7554C40.0593 90.0483 38.718 91.0851 36.9613 92.6768C35.2172 94.257 33.0855 96.3643 31.0117 98.7865C28.0056 103.081 27.4276 105.187 27.2486 107.333C27.171 108.262 26.9652 109.378 26.775 110.409C26.731 110.648 26.6879 110.882 26.6473 111.108C26.5703 111.538 26.5027 111.938 26.4543 112.294C26.5056 112.2 26.5589 112.101 26.6142 111.998C26.6591 111.915 26.7053 111.829 26.7529 111.741C27.2103 110.894 27.7873 109.85 28.5048 108.824C29.9301 106.787 31.9717 104.732 34.8421 104.491L34.9982 104.478L35.122 104.574C37.8976 106.732 41.0717 107.244 51.3591 108.103C79.7085 109.701 98.1543 96.1196 104.526 86.9775Z'
        fill='#6A7695'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M101.902 90.4425C101.902 87.4722 101.034 85.7272 100.414 85.1074L100.981 84.5398C101.805 85.3637 102.704 87.3494 102.704 90.4425L101.902 90.4425Z'
        fill='#6A7695'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M96.354 87.4164C95.8592 85.1956 94.7803 83.6783 93.2937 82.935L93.6527 82.217C95.4144 83.0979 96.6064 84.8583 97.1375 87.2418C97.6679 89.6226 97.5482 92.654 96.672 96.1587L95.8933 95.964C96.7496 92.5389 96.8493 89.6397 96.354 87.4164Z'
        fill='#6A7695'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M90.6639 88.8991C90.5667 85.6456 89.3082 83.2328 87.5704 81.4951L88.138 80.9275C90.0124 82.8019 91.3626 85.4061 91.4662 88.8752C91.5695 92.3342 90.4328 96.6224 87.3991 101.881L86.7039 101.48C89.6905 96.3029 90.7613 92.1627 90.6639 88.8991Z'
        fill='#6A7695'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M82.251 94.4951C83.6239 89.7391 82.8431 84.7187 81.0637 80.5667L81.8015 80.2505C83.6342 84.5269 84.4589 89.7409 83.0223 94.7177C81.5813 99.7096 77.88 104.411 70.7629 107.664L70.4292 106.934C77.3595 103.766 80.8825 99.2361 82.251 94.4951Z'
        fill='#6A7695'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M71.4449 95.6239C73.9966 90.7659 74.0073 85.4471 73.4085 80.4565L74.2055 80.3608C74.8106 85.404 74.8214 90.9218 72.1555 95.9972C69.484 101.083 64.1646 105.652 54.2653 108.885L54.0161 108.122C63.783 104.933 68.8988 100.471 71.4449 95.6239Z'
        fill='#6A7695'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M57.1649 98.2673C61.243 94.28 63.0342 88.6755 63.775 81.1719L64.5738 81.2507C63.8262 88.8233 62.0052 94.6574 57.726 98.8413C53.451 103.021 46.7901 105.488 36.5202 106.495L36.4419 105.696C46.641 104.696 53.0826 102.259 57.1649 98.2673Z'
        fill='#6A7695'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M44.1834 95.9797C47.5094 93.4369 49.5939 89.6596 51.7956 83.6548L52.5493 83.9311C50.3361 89.9669 48.1871 93.9292 44.6709 96.6174C41.1614 99.3006 36.3452 100.672 28.9093 101.677L28.8018 100.881C36.2159 99.8792 40.8507 98.5277 44.1834 95.9797Z'
        fill='#6A7695'
      />
      <defs>
        <linearGradient
          id='paint0_linear_11001_159644'
          x1='88.9655'
          y1='6.41378'
          x2='10.8275'
          y2='137.655'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F7F8FB' />
          <stop offset='1' stopColor='#E7EBF5' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_11001_159644'
          x1='67.1386'
          y1='81.1831'
          x2='61.2005'
          y2='113.284'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
      </defs>
    </svg>
  );
};
